import axios from "axios";

import * as moment from "moment";

import { Message, MessageDetails, ReplyCaseConversationModel } from "./models";

class MessagingApi {
    private readonly apiUrl = "/api/Messaging";

    public async getAll(caseId: string): Promise<MessageDetails[]> {
        if (!caseId) {
            return [];
        }

        const response = await axios.get(`${this.apiUrl}/${caseId}`);
        const messageDetails = response.data as MessageDetails[];

        return messageDetails.map(message => {
            return this.parseMessageDetails(message);
        });
    }

    public async getCaseConversation(caseId: string, subject: string): Promise<MessageDetails[]> {
        const response = await axios.get(`${this.apiUrl}/${caseId}/GetCaseConversation/${subject}`);
        const messageDetails = response.data as MessageDetails[];

        return messageDetails.map(message => {
            return this.parseMessageDetails(message);
        });
    }

    public async replyCaseConversation(message: Message, caseId: string, customerId?: string): Promise<ReplyCaseConversationModel> {
        const response = await axios.post(`${this.apiUrl}/${caseId}/Reply?customerId=${customerId}`, message);
        const messageDetails = response.data as ReplyCaseConversationModel;

        messageDetails.messageDetails = this.parseMessageDetails(messageDetails.messageDetails);
        return messageDetails;
    }

    public async create(message: Message, caseId: string, customerId?: string): Promise<MessageDetails> {
        const response = await axios.post(`${this.apiUrl}/${caseId}?customerId=${customerId}`, message);
        const messageDetails = response.data as MessageDetails;

        return this.parseMessageDetails(messageDetails);
    }

    public parseMessageDetails(model: MessageDetails): MessageDetails {
        model.subjectStartDate = moment(model.subjectStartDate);
        model.messages = model.messages.map(messages => {
            return ({
                ...messages,
                dateCreated: moment(messages.dateCreated)
            });
        });

        return model;
    }
}

export const messagingApi = new MessagingApi();
